(function () {
    const header = () => {
        const header = document.querySelector(".shopify-section-header");
        const headerAlways = document.querySelector(".header-always");

        if (headerAlways) {
            header.classList.add("always-show");
        }

        const menu = document.querySelector(".list-menu--inline");
        const menuLinks = document.querySelectorAll(".list-menu-item");
        const search = document.querySelector(".header__search");

        header.addEventListener("keydown", (e) => {
            if (e.code === "Escape" && search && search.isOpen) {
                search.close();
            }
        });

        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);

        const annBar = document.querySelector(".section-announcement");
        const annBarObserver = new IntersectionObserver((entries) => {
            const [entry] = entries;

            if (entry.isIntersecting) {
                document.documentElement.style.setProperty(
                    "--ann-height",
                    `${entry.intersectionRect.height}px`
                );
            } else {
                document.documentElement.style.setProperty("--ann-height", `0px`);
            }
        });
        if (annBar) annBarObserver.observe(annBar);

        const addBackground = () => {
            if (document.querySelector(".overflow-hidden-drawer")) {
                return;
            }

            if (document.querySelector(".always-show")) {
                return;
            }

            const headerObserver = new ResizeObserver((entries) => {
                const [entry] = entries;
                if (entry.contentRect.width >= 1200) {
                    if (
                        header.classList.contains("color-background-2") &&
                        !header.classList.contains("shopify-section-header-sticky")
                    ) {
                        header.classList.remove("color-background-2");
                    }

                    if (
                        header.classList.contains("section--have-overlay") &&
                        !header.classList.contains("shopify-section-header-sticky")
                    ) {
                        header.classList.add("have-background");
                    }
                }
            });

            headerObserver.observe(header);
        };

        const removeBackground = () => {
            if (
                document.querySelector(".overflow-hidden") ||
                document.querySelector(".overflow-hidden-drawer")
            ) {
                return;
            }

            if (document.querySelector(".always-show")) {
                return;
            }

            const headerObserver = new ResizeObserver((entries) => {
                const [entry] = entries;
                if (entry.contentRect.width >= 1200) {
                    if (
                        header.classList.contains("color-background-1") &&
                        !header.classList.contains("shopify-section-header-sticky")
                    ) {
                        header.classList.add("color-background-2");
                    }

                    if (
                        header.classList.contains("section--have-overlay") &&
                        !header.classList.contains("shopify-section-header-sticky")
                    ) {
                        header.classList.remove("have-background");
                    }
                }
            });

            headerObserver.observe(header);
        };

        header.addEventListener("mouseenter", addBackground);
        header.addEventListener("focus", addBackground);
        header.addEventListener("focusin", addBackground);
        header.addEventListener("mouseleave", removeBackground);
        header.addEventListener("focusout", removeBackground);

        document.addEventListener("DOMContentLoaded", () => {
            const firstSection = document.querySelector("main .shopify-section:first-child:not(.not-margin) .section--has-overlay:not(.article-template__header)");
            let isSectionVisible = false;
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting && !isSectionVisible) {
                        isSectionVisible = true;
                        header.classList.add("entering-section", "color-background-2");
                    } else if (!entry.isIntersecting && isSectionVisible) {
                        isSectionVisible = false;
                        header.classList.remove("entering-section");
                    }
                },
                { threshold: 0.15 }
            );

            if (firstSection) {
                observer.observe(firstSection);
            }

            window.addEventListener("scroll", () => {
                if (isSectionVisible) {
                    header.classList.add("entering-section", "color-background-2");
                }
            });
        });

        const main = document.querySelector("main");
        const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
        
        // Safety check falls main leer ist oder keine Sections hat
        const firstMainSection = main ? main.querySelectorAll(".shopify-section")[0] : null;

        if (
            firstMainSection?.classList.contains("section--has-overlay") &&
            !firstMainSection?.classList.contains("not-margin")
        ) {
            header.classList.add("color-background-1", "color-background-2");
            if (breadcrumbs) {
                breadcrumbs.classList.add("color-background-2");
            }
        }
    };

    header();

    document.addEventListener("shopify:section:load", header);
    document.addEventListener("shopify:section:unload", header);
    document.addEventListener("shopify:section:reorder", header);
})();

/* --- HEADER DRAWER (Mobile Menu) --- */
if (!customElements.get('header-drawer')) {
  customElements.define('header-drawer', class HeaderDrawer extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      if (!this.mainDetailsToggle) return;

      this.summary = this.mainDetailsToggle.querySelector('summary');
      if (!this.summary) return;

      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    }

    onSummaryClick(event) {
      event.preventDefault();
      const isOpen = this.mainDetailsToggle.hasAttribute('open');
      if (isOpen) {
        this.mainDetailsToggle.removeAttribute('open');
        document.body.classList.remove('overflow-hidden-tablet');
      } else {
        this.mainDetailsToggle.setAttribute('open', true);
        document.body.classList.add('overflow-hidden-tablet');
      }
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.mainDetailsToggle.removeAttribute('open');
      document.body.classList.remove('overflow-hidden-tablet');
    }

    onFocusOut(event) {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          this.mainDetailsToggle.removeAttribute('open');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      }, 100);
    }
  });
}

/* --- LANGUAGE SELECTOR --- */
document.addEventListener('DOMContentLoaded', function () {
    const languageButton = document.querySelector('.header__localization-lang-button');
    const languageList = document.querySelector('#HeaderLanguageList');

    if (languageButton && languageList) {
        languageButton.addEventListener('click', function (event) {
            event.preventDefault();
            if (languageList.hasAttribute('hidden')) {
                languageList.removeAttribute('hidden'); 
                languageButton.setAttribute('aria-expanded', 'true');
            } else {
                languageList.setAttribute('hidden', '');
                languageButton.setAttribute('aria-expanded', 'false');
            }
        });

        languageList.addEventListener('click', function (event) {
            const selectedLang = event.target.closest('a');
            if (selectedLang) {
                const langValue = selectedLang.getAttribute('data-value');
                changeLanguage(langValue);
            }
        });
    }
});

function changeLanguage(langValue) {
    const form = document.getElementById('HeaderLanguageForm');
    if (form) {
        const localeInput = document.createElement('input');
        localeInput.type = 'hidden';
        localeInput.name = 'locale_code';
        localeInput.value = langValue;
        form.appendChild(localeInput);
        form.submit();
    }
}

/* --- SEARCH MODAL LOGIC (FIXED) --- */
document.addEventListener('DOMContentLoaded', function() {
    const searchIcon = document.getElementById('search-icon-open');
    const searchModal = document.getElementById('search-modal') || document.querySelector('search-modal');
    const searchClose = document.getElementById('search-modal-close');
    const searchOverlay = document.getElementById('SearchModal-Overlay');

    function openSearch() {
        if (!searchModal) return;
        // Für Custom Elements und CSS
        searchModal.setAttribute('open', '');
        searchModal.classList.add('active');
        searchModal.classList.add('open'); // Manche Themes nutzen .open, manche .active
        document.body.classList.add('overflow-hidden');
        
        // Fokus auf Input setzen
        const input = searchModal.querySelector('input[type="search"]');
        if (input) setTimeout(() => input.focus(), 100);
    }

    function closeSearch() {
        if (!searchModal) return;
        searchModal.removeAttribute('open');
        searchModal.classList.remove('active');
        searchModal.classList.remove('open');
        document.body.classList.remove('overflow-hidden');
    }

    // Event Listeners
    if (searchIcon) {
        searchIcon.style.cursor = 'pointer';
        searchIcon.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openSearch();
        });
    }

    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

    // ESC Taste
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && searchModal && searchModal.hasAttribute('open')) {
            closeSearch();
        }
    });
});

/* --- GENERAL POPUPS --- */
document.addEventListener('DOMContentLoaded', function() {
    const modalOpeners = document.querySelectorAll('modal-opener');
    const header = document.querySelector('.shopify-section-header');

    if (modalOpeners.length > 0) {
        modalOpeners.forEach(opener => {
            opener.addEventListener('click', function(e) {
                if(header) header.classList.add('popup-active');
                const modalId = this.getAttribute('data-modal');
                if (!modalId) return;
                const modal = document.querySelector(modalId);
                if (modal) {
                    modal.style.display = 'block';
                    modal.setAttribute('open', '');
                } 
            });
        });
    }

    const closeModalButtons = document.querySelectorAll('.modal-close-button'); 
    if (closeModalButtons.length > 0) {
        closeModalButtons.forEach(button => {
            button.addEventListener('click', function() {
                if(header) header.classList.remove('popup-active');
                const modal = this.closest('.modal') || this.closest('modal-dialog'); 
                if (modal) {
                    modal.style.display = 'none'; 
                    modal.removeAttribute('open');
                }
            });
        });
    }
});